import { haveValue } from '@app/modules/shares/utils/functions/form';
import { Component, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core'
import { NG_VALUE_ACCESSOR } from '@angular/forms'
import { DateFormatDirective } from '../../directives/date-format.directive'
import { NzDatePickerComponent } from "ng-zorro-antd/date-picker"
import { AbstractControlComponent } from '../../../classes/abstract-control.component'
import { VssUiConfig } from '../../../vss-ui.model'
import { en_US, NzI18nService, vi_VN } from 'ng-zorro-antd/i18n'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'vss-ui-date-picker',
  templateUrl: './cs-date-picker.component.html',
  styleUrls: ['./cs-date-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CsDatePickerComponent),
      multi: true
    },
    DateFormatDirective
  ],
  encapsulation: ViewEncapsulation.None,
})
export class CsDatePickerComponent extends AbstractControlComponent<Date | string | number> implements OnInit {

  @ViewChild('datePickerComponent') datePickerComponent!: NzDatePickerComponent
  @Input() csFormat!: string
  @Input() csDefaultPickerValue!: Date
  @Input() csMode: 'date' | 'week' | 'month' | 'year' = 'date';
  @Input() csLocale: any
  @Input() csIsValidateRange: boolean = true;
  @Input() csIsError: boolean = false;
  @Input() csShowTime: boolean = false;
  @Input() csShowToday: boolean = true;
  @Input() csRangePicker: boolean = false;
  @Input() csDisabledDate!: (current: Date) => boolean
  @Input() ranges?: { [key: string]: Date[] } | { [key: string]: () => Date[] }
  @Input() csInline: boolean = false;
  @Input() csDropdownClassName: string = '';
  @Input() timeFormat: object = { nzFormat: 'HH:mm' };
  @Output() csOnCalendarChange = new EventEmitter<any>()
  @Input() csAllowClear: boolean = true;
  @Input() csPlaceholder: any = null;
  rangesDate?: { [key: string]: Date[] } | { [key: string]: () => Date[] }
  currentLang: any = ''

  constructor(
    private _vssConfig: VssUiConfig,
    private i18n: NzI18nService,
    private translateService: TranslateService
  ) {
    super()
    this.rangesDate = _vssConfig.rangesDate
    this.currentLang = localStorage.getItem('language')
    this.i18n.setLocale(vi_VN)
    // bao giờ có đa ngôn ngữ thì mở lại
    // this.i18n.setLocale(this.currentLang === 'vi' ? vi_VN : en_US);
  }

  ngOnInit() {
    if (!this.csFormat) {
      this.csFormat = this.csShowTime ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy'
    }

    this.csPlaceholder = this.csPlaceholder ? this.csPlaceholder.map((key: any) => this.translateService.instant(key)) : [ this.translateService.instant('BASE.FROM_DATE'), this.translateService.instant('BASE.TO_DATE') ]
  }

  onCalendarChange(e: (Date | null)[]) {
    this.csOnCalendarChange.emit(e)
  }

  onBlur(event: any): void {
    if (!haveValue(event?.target?.value)) {
      // Thực hiện các hành động cần thiết khi giá trị bị xóa
      this.onChangeFn('')
      this.csChange.emit('')
    }
  }
}
